// Tutorial footer — the honest scope statement (the workbook is fully
// replaced now, Slide Page included, and a current .xlsx can be exported
// from the Budget page) and a pointer to the review queue as the daily
// driver.

import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function FooterSection() {
  const navigate = useNavigate();
  return (
    <footer className="tut-footer">
      <div className="tut-footer-inner">
        <p className="tut-footer-state">
          This replaces the forecast tabs, the Actual-to-Budget sheet, the By&nbsp;Function
          rollup, and the Slide&nbsp;Page exec summary of <strong>Tax Budget FY2026.xlsx</strong>.
          Need a workbook for someone outside ERBI? Export a current .xlsx from the Budget page
          any time.
        </p>
        <p className="tut-footer-note">
          Day to day, start in the <strong>review queue</strong> — it’s where the few SAP rows
          that need your judgment wait, and every answer you give there makes the next quarter
          quieter.
        </p>
        <div className="tut-footer-ctas">
          <button type="button" className="tut-btn primary" onClick={() => navigate('/budget/review')}>
            Open the review queue
          </button>
          <button type="button" className="tut-btn ghost-light" onClick={() => navigate('/budget')}>
            Go to the dashboard
          </button>
        </div>
      </div>
    </footer>
  );
}
